import React, { useEffect, useState } from "react";
import { FaceLivenessDetector } from "@aws-amplify/ui-react-liveness";
import { ThemeProvider, useTheme } from "@aws-amplify/ui-react";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-providers";
import { useTranslation } from "react-i18next";
import awsConfig from "../../aws-exports";
import "./index.css";
function LivenessDetector() {
  const [loading, setLoading] = useState(true);
  const [sessionId, setSessionId] = useState(null);
  const { t, i18n } = useTranslation();

  const credentialsProvider = fromCognitoIdentityPool({
    identityPoolId: awsConfig.identityPoolId,
    clientConfig: { region: awsConfig.region },
  });

  const sendMessage = (data) => {
    window.parent.postMessage(data, "*");
    // 给flutter发消息
    if (window.facedetect) {
      window.facedetect.postMessage(JSON.stringify(data));
    }
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const sessionIdFromQuery = queryParams.get("sessionId");

    if (sessionIdFromQuery) {
      setSessionId(sessionIdFromQuery);
      setLoading(false);
    } else {
      console.error("No sessionId found in query string");
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!loading) {
      sendMessage({
        act: "loaded",
      });
    }
  }, [loading]);
  

  useEffect(() => {
    if (loading) {
      return undefined;
    }

    const toastText = t("liveness.toastTip");
    const language = i18n.language || "en";
    const isRtl = language.startsWith("ar");

    const appendToastHint = () => {
      const toastContainer = document.querySelector(
        ".amplify-liveness-toast__container"
      );

      if (!toastContainer) {
        return false;
      }

      const existingHint = toastContainer.querySelector(
        ".custom-liveness-toast-tip"
      );
      if (existingHint) {
        existingHint.remove();
      }

      const customContent = document.createElement("div");
      customContent.className = "custom-liveness-toast-tip";
      customContent.style.color = "#999";
      customContent.style.fontSize = "12px";
      customContent.style.lineHeight = "18px";
      customContent.style.textAlign = isRtl ? "right" : "left";
      customContent.lang = language;
      customContent.dir = isRtl ? "rtl" : "ltr";
      customContent.textContent = toastText;

      toastContainer.appendChild(customContent);
      return true;
    };

    if (appendToastHint()) {
      return undefined;
    }

    const observer = new MutationObserver((_, obs) => {
      if (appendToastHint()) {
        obs.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, [loading, i18n.language, t]);

  const handleAnalysisComplete = () => {
    // 根据返回的结果进行后续处理
    sendMessage({
      act: "complete",
      sessionId: sessionId,
    });
  };

  const { tokens } = useTheme();
  const theme = {
    name: "Face Liveness Example Theme",
    tokens: {
      space: {
        xxxl: "24px",
      },
      colors: {
        background: {
          primary: {
            // value: tokens.colors.neutral["90"].value,
            value: "#262230",
            // value: "linear-gradient(202deg, #FFFAF2 9%, #FFEBEA 75.62%), #FFF;",
          },
          secondary: {
            value: tokens.colors.neutral["100"].value,
          },
        },
        font: {
          primary: {
            // value: tokens.colors.white.value,
            value: "#FFFFFF",
          },
        },
        // brand: {
        //   primary: {
        //     10: "#FC5C20", // 最浅（用于 hover/active 状态）
        //     20: "#FC5C20", // 稍浅
        //     40: "#FC5C20", // 中等
        //     60: "#FC5C20", // 默认品牌色
        //     80: "#FC5C20", // 稍深
        //     90: "#FC5C20", // 更深
        //     100: "#FC5C20", // 最深（用于 pressed 状态）
        //   },
        // },
        // primary: {
        //   10: "#FC5C20", // 最浅（用于 hover/active 状态）
        //   20: "#FC5C20", // 稍浅
        //   40: "#FC5C20", // 中等
        //   60: "#FC5C20", // 默认品牌色
        //   80: "#FC5C20", // 稍深
        //   90: "#FC5C20", // 更深
        //   100: "#FC5C20", // 最深（用于 pressed 状态）
        // },
      },
      components: {
            Radii: { value: '30px' },

        button: {
          primary: {
            // backgroundColor: { value: '#4F46E5' },     // 背景色
            color:{ value: '#ffffff' },     // 字体颜色
          },
        },
      },
    },
  };

  return (
    <div className="viva-detector">
      <ThemeProvider theme={theme}>
        {loading ? (
          ""
        ) : (
          <FaceLivenessDetector
            sessionId={sessionId}
            region="us-east-1"
            onAnalysisComplete={handleAnalysisComplete}
            config={{
              credentialProvider: credentialsProvider,
            }}
            onUserCancel={() => {
              sendMessage({
                act: "restart",
              });
            }}
            displayText={{
              startScreenBeginCheckText: t("liveness.startScreenBeginCheckText"),
              hintCenterFaceText: t("liveness.hintCenterFace"),
              hintTooFarText: t("liveness.hintTooFarText"),
              hintHoldFaceForFreshnessText: t("liveness.hintHoldFaceForFreshnessText"),
            }}
            onError={(error) => {
              console.error(error);
              if (error.state === "CAMERA_ACCESS_ERROR") {
                sendMessage({
                  act: "showCameraAccessError",
                });
              }
            }}
            components={{ PhotosensitiveWarning: () => "" }}
          />
        )}
      </ThemeProvider>
    </div>
  );
}

export default LivenessDetector;
